import { render, staticRenderFns } from "./StoreAdminsList.vue?vue&type=template&id=0619abfc&scoped=true&"
import script from "./StoreAdminsList.vue?vue&type=script&lang=ts&"
export * from "./StoreAdminsList.vue?vue&type=script&lang=ts&"
import style0 from "./StoreAdminsList.vue?vue&type=style&index=0&id=0619abfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0619abfc",
  null
  
)

export default component.exports